import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';
import SignInPageView from './components/views/SignInPageView';
import SignUpPageView from './components/views/SignUpPageView';
import SignOutPageView from './components/views/SignOutPageView';
import ForceChangePasswordView from './components/views/ForceChangePasswordView';
import ForgotPasswordView from './components/views/ForgotPasswordView';
import ResetPasswordView from './components/views/ResetPasswordView';

const blankAuthLayout = {
	layout: {
		config: {
			navbar: { display: false },
			toolbar: { display: false },
			footer: { display: false },
			leftSidePanel: { display: false },
			rightSidePanel: { display: false }
		}
	}
};

const route: FuseRouteItemType = {
	children: [
		{
			path: 'sign-in',
			element: <SignInPageView />,
			settings: {
				layout: {
					config: {
						navbar: {
							display: false
						},
						toolbar: {
							display: false
						},
						footer: {
							display: false
						},
						leftSidePanel: {
							display: false
						},
						rightSidePanel: {
							display: false
						}
					}
				}
			},
			auth: authRoles.onlyGuest // []
		},
		{
			path: 'change-password',
			element: <ForceChangePasswordView />,
			settings: {
				layout: {
					config: {
						navbar: { display: false },
						toolbar: { display: false },
						footer: { display: false },
						leftSidePanel: { display: false },
						rightSidePanel: { display: false }
					}
				}
			},
			auth: null
		},
		{
			path: 'sign-up',
			element: <SignUpPageView />,
			settings: {
				layout: {
					config: {
						navbar: {
							display: false
						},
						toolbar: {
							display: false
						},
						footer: {
							display: false
						},
						leftSidePanel: {
							display: false
						},
						rightSidePanel: {
							display: false
						}
					}
				}
			},
			auth: authRoles.onlyGuest
		},
		{
			path: 'sign-out',
			element: <SignOutPageView />,
			settings: {
				layout: {
					config: {
						navbar: {
							display: false
						},
						toolbar: {
							display: false
						},
						footer: {
							display: false
						},
						leftSidePanel: {
							display: false
						},
						rightSidePanel: {
							display: false
						}
					}
				}
			},
			auth: null
		},
		{
			path: 'forgot-password',
			element: <ForgotPasswordView />,
			settings: blankAuthLayout,
			auth: authRoles.onlyGuest
		},
		{
			// Allowed for both guests and authenticated-but-stale sessions, because the reset
			// link is delivered by email and the user may open it in any tab.
			path: 'reset-password',
			element: <ResetPasswordView />,
			settings: blankAuthLayout,
			auth: null
		}
	]
};

export default route;
